import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StepperSequence, DottedVerticalLine } from "../../assets/svgs";
import "./styles.scss";

const StepperSection = ({ heading, data, containerStyle = {} }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div div className="stepper-section-container" style={containerStyle}>
      {heading ? (
        <p className="stepper-section-heading">
          {t(`${routeName}.${heading}`)}
        </p>
      ) : null}
      {data?.map(section => {
        return (
          <>
            <div className="step-header-content">
              <div className="stepper-icon-wrapper">
                <img src={StepperSequence} alt="step" />
                <span className="sequence-number">{section?.sequence}</span>
              </div>
              <strong>{t(`${routeName}.${section?.title}`)}</strong>
            </div>
            <div className="step-header-content description-wrapper">
              <div className="vertical-line-wrapper">
                <img src={DottedVerticalLine} alt="dotted-line" />
              </div>
              <p>{t(`${routeName}.${section?.description}`)}</p>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default StepperSection;
